import axios from "axios";
export const state = {
    purchases: [],
    purchase_list: [],
};
export const getters = {
    Purchases: state => state.purchases,
    Purchase: state => state.purchase_list
};

export const mutations = {
    SET_PURCHASES(state, newValue) {
        state.purchases = newValue;
    },

    SET_PURCHASE(state, newValue) {
        state.purchase_list = newValue;
    }
};

export const actions = {
    fetchPurchases({ commit }) {
        axios.get('purchases').then(purchases => {
            commit('SET_PURCHASES', purchases.data)
        }).catch((error) => {
            // eslint-disable-next-line no-console
            console.log(error)
        })
    },
    fetchPurchase({ commit }) {
        axios.get('purchase').then(purchase => {
            commit('SET_PURCHASE', purchase.data)
        }).catch((error) => {
            // eslint-disable-next-line no-console
            console.log(error)
        })
    }

};